import { PaymentConfirmationComponent } from 'src/app/component/payment-confirmation/payment-confirmation.component';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { EventService } from 'src/app/services/event.service';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationService } from 'src/app/services/notification/notification.service';

import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { OrderResponseBody } from '@paypal/paypal-js';
import { User } from '@shared/models';
import { VendorsStore } from '@shared/stores';

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.page.html',
  styleUrls: ['./payment-method.page.scss'],
})
export class PaymentMethodPage implements OnInit {
  vendorsStore = inject(VendorsStore);
  amount = 200;
  user: User | null = null;
  subscriptionSelection: any | null = null;
  subscriptionRadial: any | null = null;
  balance: number = 0;

  constructor(
    private modalCtrl: ModalController,
    private apiService: ApiService,
    private router: Router,
    private eventService: EventService,
    private dataService: DataService,
    private navCtrl: NavController,
    private authService: AuthService,
    private loadingService: LoadingService,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    if (this.dataService.getData('payment-amount')) {
      this.amount = this.dataService.getData('payment-amount');
    } else if (this.dataService.getData('subscription-selection')) {
      this.subscriptionSelection = this.dataService.getData('subscription-selection');
      this.amount = this.subscriptionSelection.price;
    } else if (this.dataService.getData('subscription-radial')) {
      this.subscriptionRadial = this.dataService.getData('subscription-radial');
      this.amount = this.subscriptionRadial.price;
    }
    this.authService.getUser().then((user) => {
      this.user = user;
    });
    this.getBalance();
    this.unsetData();
  }

  ionViewWillEnter() {
    this.vendorsStore.vendorsQuery.refetch();
  }

  unsetData() {
    this.dataService.setData('payment-amount', null);
    this.dataService.setData('subscription-selection', null);
    this.dataService.setData('subscription-radial', null);
    this.dataService.setData('busticket-item', null);
  }

  getBalance() {
    this.authService.getBalance().then((balance) => {
      this.balance = balance.balance;
    });
  }

  paySubscription(method: string) {
    if (method === 'credit_card') {
      this.dataService.setData('subscription-selection', this.subscriptionSelection);
      this.router.navigate(['tecservice-transportec/wallet/balance/payment-card']);
    } else if (method === 'credit_card_paycode') {
      this.dataService.setData('subscription-selection', this.subscriptionSelection);
      this.router.navigate(['tecservice-transportec/wallet/balance/payment-card-paycode']);
    } else if (method === 'credit_card_openpay') {
      this.dataService.setData('subscription-selection', this.subscriptionSelection);
      this.router.navigate(['tecservice-transportec/wallet/balance/payment-card-openpay']);
    } else {
      this.eventService.publish('loading:present');
      this.apiService
        .postData('suscription-payments', {
          method: method.toLowerCase(),
          sto_id: this.subscriptionSelection.id,
          amount: this.amount,
          phone: this.user?.phone,
        })
        .then((res) => {
          if (res.success) {
            this.showResponse(method, res.data);
          } else {
            console.log('Error: ', res);
          }
        })
        .finally(() => {
          this.eventService.publish('loading:dismiss');
        });
    }
  }

  paySubscriptionRadial(method: string) {
    if (method === 'credit_card') {
      this.dataService.setData('subscription-radial', this.subscriptionRadial);
      this.router.navigate(['tecservice-transportec/wallet/balance/payment-card']);
    } else if (method === 'credit_card_paycode') {
      this.dataService.setData('subscription-radial', this.subscriptionRadial);
      this.router.navigate(['tecservice-transportec/wallet/balance/payment-card-paycode']);
    } else if (method === 'credit_card_openpay') {
      this.dataService.setData('subscription-selection', this.subscriptionRadial);
      this.router.navigate(['tecservice-transportec/wallet/balance/payment-card-openpay']);
    } else {
      this.eventService.publish('loading:present');
      this.apiService
        .postData('suscription-radial-payments', {
          method: method.toLowerCase(),
          suscription: this.subscriptionRadial,
          sto_id: this.subscriptionRadial.sto_id,
          amount: this.amount,
          phone: this.user?.phone,
        })
        .then((res) => {
          if (res.success) {
            this.showResponse(method, res.data);
          } else {
            console.log('Error: ', res);
          }
        })
        .finally(() => {
          this.eventService.publish('loading:dismiss');
        });
    }
  }

  pay(method: string) {
    if (this.subscriptionRadial) {
      this.paySubscriptionRadial(method);
    } else if (this.subscriptionSelection) {
      this.paySubscription(method);
    } else if (method === 'credit_card') {
      this.dataService.setData('payment-amount', this.amount);
      this.router.navigate(['tecservice-transportec/wallet/balance/payment-card']);
    } else if (method === 'credit_card_openpay') {
      this.dataService.setData('payment-amount', this.amount);
      this.router.navigate(['tecservice-transportec/wallet/balance/payment-card-openpay']);
    } else if (method === 'credit_card_paycode') {
      this.dataService.setData('payment-amount', this.amount);
      this.router.navigate(['tecservice-transportec/wallet/balance/payment-card-paycode']);
    } else {
      this.payBalance(method);
    }
  }

  onPayPalSuccess(order: OrderResponseBody) {
    this.payBalance('paypal', order);
  }

  onPayPalError(error: string) {
    this.notificationService.presentToast(error);
    this.vendorsStore.vendorsQuery.refetch();
  }

  payBalance(method: string, order: OrderResponseBody | null = null) {
    this.eventService.publish('loading:present');
    this.apiService
      .postData('pay_balance', {
        method: method.toLowerCase(),
        amount: this.amount,
        phone: this.user?.phone,
        token_paypal: order?.id,
      })
      .then((res) => {
        if (res.success) {
          this.showResponse(method, res);
        } else {
          console.log('Error: ', res);
          this.notificationService.presentToast('Error al procesar el pago, favor de comunicarse con soporte.');
        }
      })
      .finally(() => {
        this.eventService.publish('loading:dismiss');
      });
  }

  showResponse(paymentMethod: string, paymentResponse: any) {
    this.loadingService.present();
    setTimeout(() => {
      this.modalCtrl
        .create({
          component: PaymentConfirmationComponent,
          componentProps: {
            amount: this.amount,
            method: paymentMethod,
            payment: paymentResponse.data,
            order: paymentResponse.order,
          },
        })
        .then((modal) => {
          modal.present();
          modal.onDidDismiss().then(() => {
            this.navCtrl.navigateRoot(['/tecservice-transportec/wallet/transactions']);
          });
          this.loadingService.dismiss();
        });
    }, 1000);
  }
}
